/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_Report_TitleInputs */



/**
* | output |
* | --- |
* | "Report and follow-up" |
*
* @param {Onboarding_Value_Report_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_report_title = /** @type {((inputs?: Onboarding_Value_Report_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_Report_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verslag en opvolging")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte rendu et suivi")
	return /** @type {LocalizedString} */ ("Report and follow-up")
});